import { TMapping } from 'shared/types'

export const SOURCE_NAMES: TMapping = {
  spotify: 'Spotify',
  kworb: 'kworb.net',
  gfk: 'GfK',
  musictrace: 'MusicTrace',
  opus: 'WMG Data Fabric',
  apple_music: 'Apple Music API'
}
